import React, { useRef } from "react";
import DownloadExcel from "../../Extra/DownloadExcel";

const CrewUtilizationTable = ({ data }) => {
  // console.log(data);
  const tableRef = useRef();
  return (
    <div className="newUiBody">
      <div
        className="table-responsive  p-0 m-0"
        style={{ maxHeight: "500px", overflow: "auto" }}
      >
        <table
          className="table newUiTable table-striped table-hover  "
          ref={tableRef}
        >
          <thead className="sticky-top " style={{ zIndex: 2 }}>
            <tr className="table-dark  ">
              <th>SNo</th>
              <th>Year</th>
              <th>Month</th>
              <th>Lobby</th>
              <th>No of Crew</th>
              <th>Running Duty Hrs</th>
              <th>NonRun Duty Hrs</th>
              <th>Total Duty Hrs(FGHT)</th>
              <th>Total Duty Hrs</th>
              <th>Leave Days</th>
              <th>Sick Leave Days</th>
              <th>Absent Days</th>
              <th>Test & Training Days</th>
              <th>Other NonLeave Days</th>
              <th>No of Trips</th>
              <th>Footplate Kms(FGHT)</th>
              <th>Footplate Kms</th>
              <th>Utilization % (FGHT)</th>
              <th>Utilization % </th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((obj, ind) => {
                let showTotalRow = false;
                let sumResult = null;

                // Check if month changes compared to previous row
                if (
                  ind > 0 &&
                  (data[ind - 1].ut_month !== obj.ut_month ||
                    data.length - 1 === ind)
                ) {
                  showTotalRow = true;

                  // Filter all rows with the previous month and same year
                  const rowsToSum = data.filter(
                    (d) =>
                      d.ut_month === data[ind - 1].ut_month &&
                      d.ut_year === data[ind - 1].ut_year
                  );

                  // Sum numeric values
                  sumResult = rowsToSum.reduce((acc, curr) => {
                    for (let key in curr) {
                      if (typeof curr[key] === "number") {
                        acc[key] = (acc[key] || 0) + curr[key];
                      }
                    }
                    return acc;
                  }, {});

                  // console.log(sumResult);
                }

                return (
                  <React.Fragment key={ind}>
                    {ind === data.length - 1 ||
                      (showTotalRow && (
                        <tr
                          className="table-dark "
                          style={{ fontSize: "bold" }}
                        >
                          <td colSpan={4} className="text-center fw-bold">
                            Total for {data[ind - 1].ut_month}
                          </td>
                          <td>{sumResult.ut_no_of_crew}</td>
                          <td>{sumResult.ut_running_duty_hrs}</td>
                          <td>{sumResult.ut_non_running_duty_hrs}</td>
                          <td>{sumResult.ut_total_duty_hrs_fght}</td>
                          <td>{sumResult.ut_total_duty_hrs}</td>
                          <td>{sumResult.ut_leave_days}</td>
                          <td>{sumResult.ut_sick_leave_days}</td>
                          <td>{sumResult.ut_absent_days}</td>
                          <td>{sumResult.ut_test_and_training_days}</td>
                          <td>{sumResult.ut_other_non_leave_days}</td>
                          <td>{sumResult.ut_no_of_trips}</td>
                          <td>{sumResult.ut_footplate_kms_fght}</td>
                          <td>{sumResult.ut_footplate_kms}</td>
                          <td>{sumResult.ut_percentage_util_fght}</td>
                          <td>{sumResult.ut_percentage_util}</td>
                        </tr>
                      ))}

                    <tr
                      className={obj.wh_lobby === "TOTAL" ? "table-dark" : ""}
                    >
                      <td>{ind + 1}</td>
                      <td>{obj.ut_year}</td>
                      <td>{obj.ut_month}</td>
                      <td>{obj.ut_lobby}</td>
                      <td>{obj.ut_no_of_crew}</td>
                      <td>{obj.ut_running_duty_hrs}</td>
                      <td>{obj.ut_non_running_duty_hrs}</td>
                      <td>{obj.ut_total_duty_hrs_fght}</td>
                      <td>{obj.ut_total_duty_hrs}</td>
                      <td>{obj.ut_leave_days}</td>
                      <td>{obj.ut_sick_leave_days}</td>
                      <td>{obj.ut_absent_days}</td>
                      <td>{obj.ut_test_and_training_days}</td>
                      <td>{obj.ut_other_non_leave_days}</td>
                      <td>{obj.ut_no_of_trips}</td>
                      <td>{obj.ut_footplate_kms_fght}</td>
                      <td>{obj.ut_footplate_kms}</td>
                      <td>{obj.ut_percentage_util_fght}</td>
                      <td>{obj.ut_percentage_util}</td>
                    </tr>
                    {ind === data.length - 1 && showTotalRow && (
                      <tr className="table-dark">
                        <td colSpan={4} className="text-center fw-bold">
                          Total for {data[ind - 1].ut_month}
                        </td>
                        <td>{sumResult.ut_no_of_crew}</td>
                        <td>{sumResult.ut_running_duty_hrs}</td>
                        <td>{sumResult.ut_non_running_duty_hrs}</td>
                        <td>{sumResult.ut_total_duty_hrs_fght}</td>
                        <td>{sumResult.ut_total_duty_hrs}</td>
                        <td>{sumResult.ut_leave_days}</td>
                        <td>{sumResult.ut_sick_leave_days}</td>
                        <td>{sumResult.ut_absent_days}</td>
                        <td>{sumResult.ut_test_and_training_days}</td>
                        <td>{sumResult.ut_other_non_leave_days}</td>
                        <td>{sumResult.ut_no_of_trips}</td>
                        <td>{sumResult.ut_footplate_kms_fght}</td>
                        <td>{sumResult.ut_footplate_kms}</td>
                        <td>{sumResult.ut_percentage_util_fght}</td>
                        <td>{sumResult.ut_percentage_util}</td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`crew utilization`} />
    </div>
  );
};
export default CrewUtilizationTable;
